import React, { useEffect, useState } from "react";
import TacticalVisualizer from "./TacticalVisualizer";
import CodeVisualizer from "./CodeVisualizer";

function Banner({ content }) {
  const { id, banner, color, atmosphere } = content;
  const [displayHeadline, setDisplayHeadline] = useState("");
  const [sysStatus, setSysStatus] = useState("OPERATIONAL");

  useEffect(() => {
    let i = 0;
    const fullText = banner.headline;
    setDisplayHeadline("");
    const timer = setInterval(() => {
      if (i < fullText.length) {
        setDisplayHeadline(fullText.substring(0, i + 1));
        i++;
      } else { clearInterval(timer); }
    }, 40);

    const statusList = ["MONITORING", "SECURE", "SYNCHRONIZED", "OPERATIONAL"];
    let sIdx = 0;
    const statusTimer = setInterval(() => {
       setSysStatus(statusList[sIdx % statusList.length]);
       sIdx++;
    }, 2500);

    return () => { 
        clearInterval(timer); 
        clearInterval(statusTimer);
    };
  }, [banner.headline]);

  const scrollToPricing = () => {
    const element = document.getElementById("pricing");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const renderVisualizer = () => {
    if (id === "software") {
      return <CodeVisualizer />;
    }
    return <TacticalVisualizer atmosphere={atmosphere} color={color} />;
  };

  return (
    <section id="hero" style={{
      position: "relative", minHeight: "100vh", display: "flex", alignItems: "center",
      overflow: "hidden", background: "#010108", color: "#fff", paddingTop: "80px"
    }}>
      <style>{`
        @keyframes driftBG { from { transform: translate(0,0); } to { transform: translate(-20px, -20px); } }
        .parallax-bg {
            position: absolute; inset: -50px;
            background-image: radial-gradient(${color}15 1px, transparent 1px);
            background-size: 50px 50px;
            animation: driftBG 20s linear infinite alternate;
            opacity: 0.2; z-index: 1;
        }
        @keyframes blink { 0% { opacity: 0.3; } 100% { opacity: 1; } }
      `}</style>

      <div className="parallax-bg" />
      
      <div style={{ position: "relative", zIndex: 10, width: "100%", maxWidth: "1440px", margin: "0 auto", padding: "0 40px" }}>
        <div className="row align-items-center">
          <div className="col-lg-7">
            <div style={{ marginBottom: "30px", display: "flex", alignItems: "center", gap: "10px" }}>
              <div style={{ width: "8px", height: "8px", borderRadius: "50%", background: color, boxShadow: `0 0 10px ${color}`, animation: "blink 1s infinite" }} />
              <span style={{ 
                  color: color, fontSize: "11px", fontFamily: "monospace", letterSpacing: "4px", fontWeight: "bold"
              }}>
                  SYSTEM_STATUS :: {sysStatus}
              </span>
            </div>

            <h1 style={{
              fontSize: "clamp(28px, 4vw, 60px)", fontFamily: "'Conthrax', sans-serif",
              lineHeight: 1.1, marginBottom: "35px", letterSpacing: "-1px", textTransform: "uppercase"
            }}>
              <span style={{ color: color, fontSize: "11px", display: "block", marginBottom: "15px", letterSpacing: "6px", opacity: 0.5, fontFamily: "monospace" }}>>> {banner.subheadline?.toUpperCase() || "INITIALIZING_SEQUENCE"}</span>
              {displayHeadline}<span style={{ color: color }}>_</span>
            </h1>

            <p style={{ 
              fontSize: "17px", color: "rgba(255,255,255,0.5)", lineHeight: 1.9, 
              maxWidth: "580px", marginBottom: "50px", fontWeight: "300", fontFamily: "'Readex Pro', sans-serif"
            }}>
              {banner.desc}
            </p>

            <button 
              onClick={scrollToPricing}
              style={{
              background: "transparent", border: `1px solid ${color}`, color: "#fff",
              padding: "20px 50px", fontFamily: "'Conthrax', sans-serif", fontSize: "12px",
              cursor: "pointer", transition: "all 0.3s", borderRadius: "2px",
              boxShadow: `0 0 30px ${color}10`
            }}
            onMouseEnter={e => { e.currentTarget.style.background = color; e.currentTarget.style.color = "#000"; e.currentTarget.style.boxShadow = `0 10px 40px ${color}40`; }}
            onMouseLeave={e => { e.currentTarget.style.background = "transparent"; e.currentTarget.style.color = "#fff"; e.currentTarget.style.boxShadow = `0 0 30px ${color}10`; }}
            >
              GET CONNECTED
            </button>
          </div>

          <div className="col-lg-5 d-none d-lg-flex justify-content-center" 
            style={{ 
                perspective: "1000px"
            }}
            onMouseMove={(e) => {
                const rect = e.currentTarget.getBoundingClientRect();
                const x = (e.clientX - rect.left) / rect.width - 0.5;
                const y = (e.clientY - rect.top) / rect.height - 0.5;
                const target = e.currentTarget.querySelector('.visual-target');
                if (target) {
                  target.style.transform = `rotateY(${x * 10}deg) rotateX(${-y * 10}deg)`;
                }
            }}
            onMouseLeave={(e) => {
                const target = e.currentTarget.querySelector('.visual-target');
                if (target) {
                  target.style.transform = `rotateY(0) rotateX(0)`;
                }
            }}
          >
             <div className="visual-target" style={{ transition: "transform 0.5s ease-out", width: "100%", height: "100%", position: "relative" }}>
                {renderVisualizer()}
             </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Banner;
